import { api } from "#app/http/api";

export const deleteQuoteRequestLine = async (id: string) => {
  const response = await api.quoteRequestLines.delete.mutation({
    params: { id },
    body: {},
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
